import React from "react";
import { SectionHead } from "./Portfolio";
import { Boxes, Droplets, Layers3 } from "lucide-react";

const TECHS = [
  { icon: Layers3, name: "FDM", desc: "Filamento fundido. Robusto e económico para funcionais e protótipos.", materials: ["PLA", "PETG", "PETG-CF", "ABS", "TPU"] },
  { icon: Droplets, name: "SLA — Resina", desc: "Alta definição de superfície e detalhe fino. Ideal para peças estéticas.", materials: ["Resina Standard", "Resina Tough"] },
  { icon: Boxes, name: "SLS — Nylon", desc: "Sem suportes, peças complexas e resistentes para produção final.", materials: ["Nylon PA12"] },
];

const MATRIX = [
  { m: "PLA", r: "Média", t: "Baixa", f: "Rígido", u: "Protótipos, modelos" },
  { m: "PETG", r: "Alta", t: "Média", f: "Semi-rígido", u: "Peças funcionais" },
  { m: "PETG-CF", r: "Muito alta", t: "Média-alta", f: "Rígido", u: "Peças estruturais" },
  { m: "ABS", r: "Alta", t: "Alta", f: "Rígido", u: "Peças técnicas" },
  { m: "TPU", r: "Média", t: "Média", f: "Flexível", u: "Vedantes, amortecedores" },
  { m: "Resina Tough", r: "Alta", t: "Média", f: "Rígido", u: "Detalhe + resistência" },
  { m: "Nylon SLS", r: "Muito alta", t: "Alta", f: "Semi-flexível", u: "Produção final" },
];

export const Materials = () => (
  <div data-testid="materials-matrix">
    <SectionHead eyebrow="Materiais & Tecnologias" title="A tecnologia certa para cada peça"
      subtitle="Selecionamos consigo o processo e material ideais consoante a função, exigência mecânica e acabamento." />

    <div className="grid md:grid-cols-3 gap-6 mt-12">
      {TECHS.map((t) => (
        <div key={t.name} className="bg-ax-card border border-ax-border rounded-xl p-6 hover:border-ax-orange/50 transition-colors">
          <div className="w-11 h-11 rounded-lg bg-ax-orange/10 border border-ax-orange/30 flex items-center justify-center mb-4">
            <t.icon className="w-5 h-5 text-ax-orange" />
          </div>
          <h4 className="font-heading font-bold text-lg text-ax-text">{t.name}</h4>
          <p className="text-sm text-ax-sub mt-2 leading-relaxed">{t.desc}</p>
          <div className="flex flex-wrap gap-1.5 mt-4">
            {t.materials.map((m) => (
              <span key={m} className="font-mono text-[11px] px-2 py-0.5 rounded bg-ax-surface border border-ax-border text-ax-sub">{m}</span>
            ))}
          </div>
        </div>
      ))}
    </div>

    <div className="mt-8 overflow-x-auto rounded-xl border border-ax-border">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="bg-ax-surface text-ax-sub text-left font-mono text-xs uppercase tracking-wider">
            <th className="px-5 py-3.5">Material</th><th className="px-5 py-3.5">Resistência</th>
            <th className="px-5 py-3.5">Térmica</th><th className="px-5 py-3.5">Flexibilidade</th>
            <th className="px-5 py-3.5">Aplicação típica</th>
          </tr>
        </thead>
        <tbody>
          {MATRIX.map((row, i) => (
            <tr key={row.m} className={i % 2 ? "bg-ax-card" : "bg-ax-card/50"}>
              <td className="px-5 py-3 font-semibold text-ax-text">{row.m}</td>
              <td className="px-5 py-3 text-ax-sub">{row.r}</td>
              <td className="px-5 py-3 text-ax-sub">{row.t}</td>
              <td className="px-5 py-3 text-ax-sub">{row.f}</td>
              <td className="px-5 py-3 text-ax-sub">{row.u}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
